type ParsedLabel = {
  display_label: string;
  chord_section_label: string;
};

export default class LabelParser {
  raw_orig: string;
  parsed!: ParsedLabel;

  constructor(label_text: string | null | undefined) {
    this.raw_orig = label_text || '';
    this.parse();
  }

  private parse = (): void => {
    const parts = this.raw_orig.split('/').map((label) => label.trim());
    const display_label = parts[0] ?? '';
    const chord_section_label = parts[1] ?? display_label;

    this.parsed = { display_label, chord_section_label };
  };
}

